export default "__VITE_ASSET__dC3XbZ8V__"